import styled from "styled-components";
import theme from "./theme";
const middleGray02     = theme.colors.middleGray02;
const mainBlack = theme.colors.mainBlack;
const xxl          = theme.screens.xxl;
const xl           = theme.screens.xl;
const lg           = theme.screens.lg;

export const MainContainer = styled.div`
    margin: 20px 20px;
    display: flex;
    /* align-items: center; */
    /* display: grid;
    grid-template-areas:
        'a b'
        'c d';
    grid-gap: 20px; */
    & div img {
        cursor: pointer;
    }
`;

export const GridBox = styled.div`
    padding: 10px 20px 17px 20px;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    /* box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15); */

    & .main-section-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 12px;

        & h4 {
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
        }

        & .main-section-showmore-box {
            display: flex;
            align-items: baseline;
            color: ${middleGray02};
            font-size: 13px;

            &:hover button {
                color: ${mainBlack};
            }
        }
    }
`;

export const CustomerSummaryBox = styled.div`
    padding: 2px;
    border: 0.5px solid ${middleGray02};
    border-radius: 5px;
    width: 100%;
`;

export const MainAppContainer = styled.div<{$borderWidth:any}>`
    width: 100%;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 180px);
    border-style: solid;
    border-color: #E5E7EB;
    border-width: ${props => props.$borderWidth};

    @media ${xxl} {
        border-color: #fff;
    }
`;

export const ReservationSummaryTableBody = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    width: 100%;
    border-bottom: 0.5px solid ${middleGray02};
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    & .pay-status-box {
        height: 30px;
        line-height: 30px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
    }

    & .request-box {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    & .estimate-to-reservation-btn {
        height: 25px;
        line-height: 25px;
        border: 0.5px solid ${middleGray02};
        border-radius: 12.5px;
        color: ${mainBlack};
        font-size: 12px;
        font-weight: 600;

        &:hover {
            background-color: ${mainBlack};
            color: #FFF;
            cursor: pointer;
        }
    }
`;

export const PortfolioSummaryGridContainer = styled.div`
    /* display: flex; */
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 12px;
    margin-top: 20px;
    width: 100%;

    @media ${lg} {
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 18px;
        grid-row-gap: 26px;
    }

    & img {
        transition: all 0.4s ease-in-out;
        opacity: 0.8;
        cursor: pointer;
        object-fit: fill;

        @media ${xl} {
            width: 231px;
            height: 164px;
        }

        &:hover {
            opacity: 1;
            /* transform: scale(1.15);     */
        }
    }
`;